import Vue from 'vue'
import http from "./http.js"
import $router from "./router.js"
import moment from 'moment'
import {
	message
} from 'ant-design-vue'

const TabFun = (index) => { //tab动态切换
	let optionTitle = sessionStorage.getItem('middle_act')
	let optionRoutes = index
	if (optionTitle == '店铺列表') {
		for (let i in optionRoutes) {
			optionRoutes[i].path == "/shopQuery" ? optionRoutes[i].meta.keepAlive = true : ''
			optionRoutes[i].path == "/shopAuthDetail" ? optionRoutes[i].meta.keepAlive = true : ''
			// optionRoutes[i].path == "/supplementShopInfo" ? optionRoutes[i].meta.keepAlive = true : ''
			optionRoutes[i].path == "/setStop" ? optionRoutes[i].meta.keepAlive = true : ''
		}
	} else if (optionTitle == '申请收款账号') {
		for (let i in optionRoutes) {
			optionRoutes[i].path == "/shopApply" ? optionRoutes[i].meta.keepAlive = true : ''
		}
	} else if (optionTitle == '持有人列表') {
		for (let i in optionRoutes) {
			optionRoutes[i].path == "/holderManage" ? optionRoutes[i].meta.keepAlive = true : ''
			optionRoutes[i].path == "/holderDetail" ? optionRoutes[i].meta.keepAlive = true : ''
			optionRoutes[i].path == "/holderAddCompany" ? optionRoutes[i].meta.keepAlive = true : ''
			optionRoutes[i].path == "/holderAddLegal" ? optionRoutes[i].meta.keepAlive = true : ''
			optionRoutes[i].path == "/holderAddShareHolders" ? optionRoutes[i].meta.keepAlive = true : ''
			optionRoutes[i].path == "/holderDetailRpp" ? optionRoutes[i].meta.keepAlive = true : ''
			optionRoutes[i].path == "/businessInformation" ? optionRoutes[i].meta.keepAlive = true : ''

		}
	} else if (optionTitle == '店铺结款单查询') {
		for (let i in optionRoutes) {
			optionRoutes[i].path == "/shopSettlement" ? optionRoutes[i].meta.keepAlive = true : ''
		}
	} else if (optionTitle == '店铺订单查询') {
		for (let i in optionRoutes) {
			optionRoutes[i].path == "/shopOrder" ? optionRoutes[i].meta.keepAlive = true : ''
		}
	} else if (optionTitle == '平台账户列表') {
		for (let i in optionRoutes) {
			optionRoutes[i].path == "/account" ? optionRoutes[i].meta.keepAlive = true : ''
		}
	} else if (optionTitle == '平台账户明细') {
		for (let i in optionRoutes) {
			optionRoutes[i].path == "/accountList" ? optionRoutes[i].meta.keepAlive = true : ''
		}
	} else if (optionTitle == '全球汇款订单查询') {
		for (let i in optionRoutes) {
			optionRoutes[i].path == "/globalOrder" ? optionRoutes[i].meta.keepAlive = true : ''
			optionRoutes[i].path == "/lookdetailsTwo" ? optionRoutes[i].meta.keepAlive = true : ''
		}
	} else if (optionTitle == '全球汇款') {
		for (let i in optionRoutes) {
			optionRoutes[i].path == "/globalRemittance" ? optionRoutes[i].meta.keepAlive = true : ''
			optionRoutes[i].path == "/accListCopy" ? optionRoutes[i].meta.keepAlive = true : ''
			optionRoutes[i].path == "/retrieveMoneryListCopy" ? optionRoutes[i].meta.keepAlive = true : ''
			optionRoutes[i].path == "/lookdetailsCopy" ? optionRoutes[i].meta.keepAlive = true : ''
			optionRoutes[i].path == "/quanSubmit" ? optionRoutes[i].meta.keepAlive = true : ''
		}
	} else if (optionTitle == '结汇订单查询') {
		for (let i in optionRoutes) {
			optionRoutes[i].path == "/withdrawalList" ? optionRoutes[i].meta.keepAlive = true : ''
			optionRoutes[i].path == "/lookdetailsTwoCopy" ? optionRoutes[i].meta.keepAlive = true : ''
		}
	} else if (optionTitle == '人民币结汇') {
		for (let i in optionRoutes) {
			optionRoutes[i].path == "/withdrawal" ? optionRoutes[i].meta.keepAlive = true : ''
			optionRoutes[i].path == "/privateAcclistCopy" ? optionRoutes[i].meta.keepAlive = true : ''
			optionRoutes[i].path == "/rmbSubmit" ? optionRoutes[i].meta.keepAlive = true : ''
			optionRoutes[i].path == "/myAccountListCopy" ? optionRoutes[i].meta.keepAlive = true : ''
			optionRoutes[i].path == "/lookdetails_fuCopy" ? optionRoutes[i].meta.keepAlive = true : ''
		}
	} else if (optionTitle == '公司注册') {
		for (let i in optionRoutes) {
			optionRoutes[i].path == "/serviceCompany" ? optionRoutes[i].meta.keepAlive = true : ''
		}
	} else if (optionTitle == 'VAT注册') {
		for (let i in optionRoutes) {
			optionRoutes[i].path == "/serviceVAT" ? optionRoutes[i].meta.keepAlive = true : ''
		}
	} else if (optionTitle == '独立站') {
		for (let i in optionRoutes) {
			optionRoutes[i].path == "/serviceIndependence" ? optionRoutes[i].meta.keepAlive = true : ''
		}
	} else if (optionTitle == '亚马逊开店') {
		for (let i in optionRoutes) {
			optionRoutes[i].path == "/serviceGuide" ? optionRoutes[i].meta.keepAlive = true : ''
		}
	} else if (optionTitle == '我要投保') {
		for (let i in optionRoutes) {
			optionRoutes[i].path == "/myInsure" ? optionRoutes[i].meta.keepAlive = true : ''
			optionRoutes[i].path == "/insureRecord" ? optionRoutes[i].meta.keepAlive = true : ''
		}
	} else if (optionTitle == '我的申请查询') {
		for (let i in optionRoutes) {
			optionRoutes[i].path == "/serviceList" ? optionRoutes[i].meta.keepAlive = true : ''
			optionRoutes[i].path == "/serviceCompanyDetail" ? optionRoutes[i].meta.keepAlive = true : ''
			optionRoutes[i].path == "/serviceVATDetail" ? optionRoutes[i].meta.keepAlive = true : ''
			optionRoutes[i].path == "/serviceGuideDetail" ? optionRoutes[i].meta.keepAlive = true : ''
			optionRoutes[i].path == "/serviceIndependenceDetail" ? optionRoutes[i].meta.keepAlive = true : ''
		}
	} else if (optionTitle == '结汇收款账号') {
		for (let i in optionRoutes) {
			optionRoutes[i].path == "/myAccountList" ? optionRoutes[i].meta.keepAlive = true : ''
			optionRoutes[i].path == "/privateAcclist" ? optionRoutes[i].meta.keepAlive = true : ''
			optionRoutes[i].path == "/lookdetails_fu" ? optionRoutes[i].meta.keepAlive = true : ''
		}
	} else if (optionTitle == '全球汇款收款账号') {
		for (let i in optionRoutes) {
			optionRoutes[i].path == "/retrieveMoneryList" ? optionRoutes[i].meta.keepAlive = true : ''
			optionRoutes[i].path == "/lookdetails" ? optionRoutes[i].meta.keepAlive = true : ''
			optionRoutes[i].path == "/accList" ? optionRoutes[i].meta.keepAlive = true : ''
		}
	} else if (optionTitle == '海购卡') {
		for (let i in optionRoutes) {
			optionRoutes[i].path == "/haiMaiList" ? optionRoutes[i].meta.keepAlive = true : ''
			optionRoutes[i].path == "/haiMaiApply" ? optionRoutes[i].meta.keepAlive = true : ''
		}
	} else if (optionTitle == '我要贷款') {

		for (let i in optionRoutes) {
			optionRoutes[i].path == "/wantLoanApply" ? optionRoutes[i].meta.keepAlive = true : ''
			optionRoutes[i].path == "/loanApplyList" ? optionRoutes[i].meta.keepAlive = true : ''
			optionRoutes[i].path == "/loanApply" ? optionRoutes[i].meta.keepAlive = true : ''
			optionRoutes[i].path == "/loanApplyConfirm" ? optionRoutes[i].meta.keepAlive = true : ''
			optionRoutes[i].path == "/LoanRecordQuery" ? optionRoutes[i].meta.keepAlive = true : ''
			optionRoutes[i].path == "/ImmediateRepayment" ? optionRoutes[i].meta.keepAlive = true : ''
			optionRoutes[i].path == "/RepaymentRecordQuery" ? optionRoutes[i].meta.keepAlive = true : ''
			// loanApplyEnd 可以不用设置
		}
	} else if (optionTitle == '本土店开立') {
		for (let i in optionRoutes) {
			optionRoutes[i].path == "/shopRent" ? optionRoutes[i].meta.keepAlive = true : ''
			optionRoutes[i].path == "/shopRentTwo" ? optionRoutes[i].meta.keepAlive = true : ''
			optionRoutes[i].path == "/holderAddCompany" ? optionRoutes[i].meta.keepAlive = true : ''
		}
	} else if (optionTitle == '本土店开立查询') {
		for (let i in optionRoutes) {
			optionRoutes[i].path == "/shopRentList" ? optionRoutes[i].meta.keepAlive = true : ''
		}
	} else if (optionTitle == '小币种换美元申请') {
		for (let i in optionRoutes) {
			optionRoutes[i].path == "/currencyDollar" ? optionRoutes[i].meta.keepAlive = true : ''
		}
	} else if (optionTitle == '小币种换美元订单查询') {
		for (let i in optionRoutes) {
			optionRoutes[i].path == "/currencyDollarList" ? optionRoutes[i].meta.keepAlive = true : ''
		}
	} else if (optionTitle == '提现收款账号') {
		for (let i in optionRoutes) {
			optionRoutes[i].path == "/WithdrawalAccountList" ? optionRoutes[i].meta.keepAlive = true : ''
			optionRoutes[i].path == "/WithdrawalAccountAdd" ? optionRoutes[i].meta.keepAlive = true : ''
			optionRoutes[i].path == "/WithdrawalAccountLook" ? optionRoutes[i].meta.keepAlive = true : ''
		}
	} else if (optionTitle == '提现') {
		for (let i in optionRoutes) {
			optionRoutes[i].path == "/withdraw" ? optionRoutes[i].meta.keepAlive = true : ''
		}
	} else if (optionTitle == '提现订单查询') {
		for (let i in optionRoutes) {
			optionRoutes[i].path == "/withdrawList" ? optionRoutes[i].meta.keepAlive = true : ''
			optionRoutes[i].path == "/CashWithdrawalAccount" ? optionRoutes[i].meta.keepAlive = true : ''
		}
	} else if (optionTitle == '账号与安全') {
		for (let i in optionRoutes) {
			optionRoutes[i].path == "/accountSecurity" ? optionRoutes[i].meta.keepAlive = true : ''
			optionRoutes[i].path == "/modifyPersonalPass" ? optionRoutes[i].meta.keepAlive = true : ''
		}
	} else if (optionTitle == '小币种收款申请') {
		for (let i in optionRoutes) {
			optionRoutes[i].path == "/SmallCurrencyCollectionApplication" ? optionRoutes[i].meta.keepAlive = true :
				''
		}
	} else if (optionTitle == '小币种收款订单查询') {
		for (let i in optionRoutes) {
			optionRoutes[i].path == "/SmallCurrencyCollectionApplicationList" ? optionRoutes[i].meta.keepAlive =
				true : ''
		}
	} else if (optionTitle == '店铺收款订单查询') {
		for (let i in optionRoutes) {
			optionRoutes[i].path == "/CollectionOrderList" ? optionRoutes[i].meta.keepAlive = true : ''
		}
	} else if (optionTitle == '入库管理') {
		for (let i in optionRoutes) {
			optionRoutes[i].path == "/InventoryRecordQuery" ? optionRoutes[i].meta.keepAlive = true : ''
			optionRoutes[i].path == "/SignedMerchant" ? optionRoutes[i].meta.keepAlive = true : ''
			optionRoutes[i].path == "/HistoricalBillList" ? optionRoutes[i].meta.keepAlive = true : ''
		}
	} else if (optionTitle == '发货管理') {
		for (let i in optionRoutes) {
			optionRoutes[i].path == "/ShippingManagement" ? optionRoutes[i].meta.keepAlive = true : ''
		}
	} else if (optionTitle == '海外仓服务') {
		for (let i in optionRoutes) {
			optionRoutes[i].path == "/OverseasWarehouseService" ? optionRoutes[i].meta.keepAlive = true : ''
		}
	} else if (optionTitle == '库存管理') {
		for (let i in optionRoutes) {
			optionRoutes[i].path == "/InventoryManagement" ? optionRoutes[i].meta.keepAlive = true : ''
		}
	} else if (optionTitle == '线上订单') {
		for (let i in optionRoutes) {
			optionRoutes[i].path == "/OrderManagementList" ? optionRoutes[i].meta.keepAlive = true : ''
			optionRoutes[i].path == "/returnOrder" ? optionRoutes[i].meta.keepAlive = true : ''
			optionRoutes[i].path == "/OrderManagement" ? optionRoutes[i].meta.keepAlive = true : ''
		}
	} else if (optionTitle == '出入库查询') {
		for (let i in optionRoutes) {
			optionRoutes[i].path == "/InboundAndOutboundQuery" ? optionRoutes[i].meta.keepAlive = true : ''
		}
	} else if (optionTitle == '到货入库') {
		for (let i in optionRoutes) {
			optionRoutes[i].path == "/ArrivalWarehousing" ? optionRoutes[i].meta.keepAlive = true : ''
		}
	} else if (optionTitle == '退货管理') {
		for (let i in optionRoutes) {
			optionRoutes[i].path == "/serviceReturnOrder" ? optionRoutes[i].meta.keepAlive = true : ''
		}
	} else if (optionTitle == '发货批次管理') {
		for (let i in optionRoutes) {
			optionRoutes[i].path == "/ShipmentBatchManagement" ? optionRoutes[i].meta.keepAlive = true : ''
		}
	} else if (optionTitle == '手动发货订单') {
		for (let i in optionRoutes) {
			optionRoutes[i].path == "/FulfillOrdersManually" ? optionRoutes[i].meta.keepAlive = true : ''
		}
	} else if (optionTitle == '账单查询') {
		for (let i in optionRoutes) {
			optionRoutes[i].path == "/BillingInquiry" ? optionRoutes[i].meta.keepAlive = true : ''
		}
	} else if (optionTitle == '库存盘点') {
		for (let i in optionRoutes) {
			optionRoutes[i].path == "/InventoryRecord" ? optionRoutes[i].meta.keepAlive = true : ''
			optionRoutes[i].path == "/ServerInventoryRecord" ? optionRoutes[i].meta.keepAlive = true : ''
			optionRoutes[i].path == "/ServerInventoryRecordDetails" ? optionRoutes[i].meta.keepAlive = true : ''
		}
	} else if (optionTitle == '活动规则') {
		for (let i in optionRoutes) {
			optionRoutes[i].path == "/welfarehdh" ? optionRoutes[i].meta.keepAlive = true : ''
		}
	} else if (optionTitle == '奖励明细') {
		for (let i in optionRoutes) {
			optionRoutes[i].path == "/ActivitiesList" ? optionRoutes[i].meta.keepAlive = true : ''
		}
	} else if (optionTitle == '活动列表') {
		for (let i in optionRoutes) {
			optionRoutes[i].path == "/RewardSubsidiary" ? optionRoutes[i].meta.keepAlive = true : ''
		}
	} else if (optionTitle == '商户服务') {
		for (let i in optionRoutes) {
			optionRoutes[i].path == "/merchants" ? optionRoutes[i].meta.keepAlive = true : ''
			optionRoutes[i].path == "/addedServices" ? optionRoutes[i].meta.keepAlive = true : ''
		}
	} else if (optionTitle == '平台转账') {
		for (let i in optionRoutes) {
			optionRoutes[i].path == "/PlatformTransfer" ? optionRoutes[i].meta.keepAlive = true : ''
		}
	} else if (optionTitle == '平台转账查询') {
		for (let i in optionRoutes) {
			optionRoutes[i].path == "/TransferList" ? optionRoutes[i].meta.keepAlive = true : ''
		}
	}


}

const brrsNewFun = (index) => { //tab页面返回删除
	let middleNum = JSON.parse(sessionStorage.getItem('middle_i'))
	let brrs = JSON.parse(sessionStorage.getItem('brrs'))
	let brrsNew = brrs.slice(0, middleNum).concat(brrs.slice(middleNum + 1, brrs.length))
	sessionStorage.setItem('brrs', JSON.stringify(brrsNew))
	index.push(brrsNew[JSON.parse(sessionStorage.getItem('middle_i')) - 1].titleEn)
}

const commonProbFun = (index) => {
	let brrs = JSON.parse(sessionStorage.getItem('brrs'))
	let newarr = []
	for (let i of brrs) {
		newarr.push(i.title)
	}
	if (newarr.includes('常见问题') == false) {
		brrs.push({
			"title": "常见问题",
			"fullPath": '/commonProblem',
			"titleEn": "/commonProblem",
			"icon": "",
			"href": "shop/shopList",
			"spread": "false",
			"permissions": "shop:init",
			"children": null,
			"titleNew": "/commonProblem"
		})
	} else {
		for (let i in brrs) {
			if (brrs[i].title == '常见问题') {
				brrs[i].fullPath = '/commonProblem'
			}
		}
	}
	sessionStorage.setItem('brrs', JSON.stringify(brrs))
	sessionStorage.setItem('commonProIndex', index)
	$router.push({
		path: '/commonProblem'
	})
}

// 跳转路由,横向导航栏修改
const brrsFun = (oldTit,newTit,newUrl) => {
	let brrs = JSON.parse(sessionStorage.getItem('brrs'))
	for (let i in brrs) {
		if (brrs[i].title == oldTit) {
			brrs.splice(i, 1)
		}
	}
	let newarr = []
	for (let i of brrs) {
		newarr.push(i.title)
	}
	if (newarr.includes(newTit) == false) {
		brrs.push({
			"title": newTit,
			"fullPath": newUrl,
			"titleEn": newUrl,
			"icon": "",
			"href": "shop/shopList",
			"spread": "false",
			"permissions": "shop:init",
			"children": null,
			"titleNew": newUrl
		})
	} else {
		for (let i in brrs) {
			if (brrs[i].title == newTit) {
				brrs[i].fullPath = newUrl
			}
		}
	}
	sessionStorage.setItem('brrs', JSON.stringify(brrs))
}

// 金额
const Amount = (Amount) => {
	Amount = Amount.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
	Amount = Amount.replace(/^\./g, ''); //必须保证第一个为数字而不是. 
	Amount = Amount.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的  
	Amount = Amount.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
	Amount = Amount.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); //只能输入两个小数  
	if (Amount.indexOf(".") < 0 && Amount != "") { //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额 
		Amount = parseFloat(Amount);
	}
	if (Amount.length > 10) {
		Amount = Amount.substring(0, 10);
	}
	return Amount
}

const special = (val)=>{
	// 使用正则表达式替换掉非英文字符和数字的部分
	const formattedString = val.replace( /[^A-Za-z0-9\s+\-?().,']+/g, '');
	return formattedString;
}

// 去除中文和中文符号
const RemoveChineseAndChineseSymbols = (val) => {
	const SpacesString = val.replace(/[^\x00-\xff]/g, '');
	return SpacesString;
}

const EnglishOnly = (val)=>{
	// 使用正则表达式替换掉非英文字符和数字的部分
	const formattedString = val.replace( /[^A-Za-z\s+\-?().,']+/g, '');
	return formattedString;
}

// 入网回显文件
const viewLoadMerchantFile = async (index) => {
	let obj = ''
	await http.get('/merchantRegist/viewLoadMerchantFile?fileName=' + encodeURIComponent(index)).then(res => {
		if (res.data.code == 0) {
			obj = res.data.data

		}
	})
	return obj
}

// 海外仓回显文件
const getOssFile = async (index) => {
	let obj = ''
	await http.get('/owBatchShip/getOssFile?fileUrl=' + index).then(res => {
		if (res.data.code == 0) {
			obj = res.data.data

		}
	})
	return obj
}

// 海外仓获取状态
const listEnums = async (index) => {
	let obj = ''
	await http.get('/enums/listEnums?className=' + index).then(res => {
		if (res.data.code == 0) {
			obj = res.data.data

		}
	})
	return obj
}

// 业务节假日验证
// 业务类型：
// 1.小币种换美元：CHANGE_CURRENCY_EXCHANGE
// 2.人民币结汇：CNY_PAYMENTS
// 3.全球汇款：SEND_MONEY_ABROAD
const HolidayVerification = async (index) => {
	let obj = {
		'unusualMsg': ''
	}
	let checkDate = moment().format('YYYY-MM-DD')
	await http.get('/crossBorderRemittance/hhdCalendarCheck', {
		params: {
			'businessType': index,
			'checkDate': checkDate
		}
	}).then(res => {
		if (res.data.code == 0) {
			obj = res.data.data
			if (obj.customDescriptionFlg == 'DEFAULT') {
				obj.unusualMsg = '非交易时间，请勿发起交易！'
			} else {
				obj.unusualMsg = obj.customDescription
			}
		} else {
			message.info(res.data.msg)
		}
	})
	return obj
}

// 区号
const getMobileAreaCodes = async () => {
	let obj = {}
	const res = await http.get('/merchantRegist/getMobileAreaCodes')
	if(res.data.code =='0000'){
	    obj = res.data.data
	} else{
		message.info(res.data.msg)
	}
	return obj
}

//包括0的整数
const REG_ZERO_INTEGER_FUN = (Amount) => {
	Amount = Amount.replace(/[^\d]/g, ""); //清除“数字”以外的字符
	return Amount
}

// 圆形国家图标
const iconCountry = (value) => {
	if (value == 'CNY') {
		return 'icon-cn'
	} else if (value == 'HKD') {
		return 'icon-HDK-Y'
	} else if (value == 'USD') {
		return 'icon-USD-Y'
	} else if (value == 'JPY') {
		return 'icon-JPY-Y'
	} else if (value == 'GBP') {
		return 'icon-GBP-Y'
	} else if (value == 'EUR') {
		return 'icon-EUR-Y'
	} else if (value == 'IDR') {
		return 'icon-IDR-Y'
	} else if (value == 'PHP') {
		return 'icon-PHP-Y'
	} else if (value == 'THB') {
		return 'icon-THB-Y1'
	} else if (value == 'VND') {
		return 'icon-VND-Y'
	} else if (value == 'MYR') {
		return 'icon-MYR-Y'
	}
}

const oriDataList = () => {
	let DataList = [{
			name: '新西兰',
			key: 'NZL'
		},
		{
			name: '斐济',
			key: 'FJI'
		},
		{
			name: '巴布亚新几内亚',
			key: 'PNG'
		},
		{
			name: '圣多美和普林西比',
			key: 'STP'
		},
		{
			name: '马绍尔群岛',
			key: 'MHL'
		},
		{
			name: '古巴',
			key: 'CUB'
		},
		{
			name: '苏丹',
			key: 'SDN'
		},
		{
			name: '冈比亚',
			key: 'GMB'
		},
		{
			name: '马来西亚',
			key: 'MYS'
		},
		{
			name: '马约特岛',
			key: 'MYT'
		},
		{
			name: '中国台湾',
			key: 'TWN'
		},
		{
			name: '波兰',
			key: 'POL'
		},
		{
			name: '苏里南',
			key: 'SUR'
		},
		{
			name: '阿曼',
			key: 'OMN'
		},
		{
			name: '阿联酋',
			key: 'ARE'
		},
		{
			name: '肯尼亚',
			key: 'KEN'
		},
		{
			name: '阿根廷',
			key: 'ARG'
		},
		{
			name: '几内亚比绍',
			key: 'GNB'
		},
		{
			name: '亚美尼亚',
			key: 'ARM'
		},
		{
			name: '乌兹别克斯坦',
			key: 'UZB'
		},
		{
			name: '不丹',
			key: 'BTN'
		},
		{
			name: '多哥',
			key: 'TGO'
		},
		{
			name: '塞内加尔',
			key: 'SEN'
		},
		{
			name: '爱尔兰',
			key: 'IRL'
		},
		{
			name: '伊朗',
			key: 'IRN'
		},
		{
			name: '卡塔尔',
			key: 'QAT'
		},
		{
			name: '布隆迪',
			key: 'BDI'
		},
		{
			name: '荷兰',
			key: 'NLD'
		},
		{
			name: '斯洛伐克',
			key: 'SVK'
		},
		{
			name: '伊拉克',
			key: 'IRQ'
		},
		{
			name: '斯洛文尼亚',
			key: 'SVN'
		},
		{
			name: '赤道几内亚',
			key: 'GNQ'
		},
		{
			name: '泰国',
			key: 'THA'
		},
		{
			name: '阿鲁巴岛',
			key: 'ABW'
		},
		{
			name: '瑞典',
			key: 'SWE'
		},
		{
			name: '冰岛',
			key: 'ISL'
		},
		{
			name: '马其顿',
			key: 'MKD'
		},
		{
			name: '比利时',
			key: 'BEL'
		},
		{
			name: '列支敦士登',
			key: 'LIE'
		},
		{
			name: '以色列',
			key: 'ISR'
		},
		{
			name: '科威特',
			key: 'KWT'
		},
		{
			name: '阿尔及利亚',
			key: 'DZA'
		},
		{
			name: '贝宁',
			key: 'BEN'
		},
		{
			name: '俄罗斯联邦',
			key: 'RUS'
		},
		{
			name: '安提瓜和巴布达',
			key: 'ATG'
		},
		{
			name: '意大利',
			key: 'ITA'
		},
		{
			name: '斯威士兰',
			key: 'SWZ'
		},
		{
			name: '巴勒斯坦',
			key: 'PAL'
		},
		{
			name: '坦桑尼亚',
			key: 'TZA'
		},
		{
			name: '塞黑',
			key: 'S&M'
		},
		{
			name: '巴基斯坦',
			key: 'PAK'
		},
		{
			name: '巴拿马',
			key: 'PAN'
		},
		{
			name: '布基纳法索',
			key: 'BFA'
		},
		{
			name: '乌克兰',
			key: 'UKR'
		},
		{
			name: '新加坡',
			key: 'SGP'
		},
		{
			name: '吉尔吉斯斯坦',
			key: 'KGZ'
		},
		{
			name: '瑞士',
			key: 'CHE'
		},
		{
			name: '吉布提',
			key: 'DJI'
		},
		{
			name: '留尼汪',
			key: 'REU'
		},
		{
			name: '智利',
			key: 'CHL'
		},
		{
			name: '中国',
			key: 'CHN'
		},
		{
			name: '朝鲜',
			key: 'PRK'
		},
		{
			name: '马里',
			key: 'MLI'
		},
		{
			name: '克罗地亚',
			key: 'HRV'
		},
		{
			name: '博茨瓦纳',
			key: 'BWA'
		},
		{
			name: '柬埔寨',
			key: 'KHM'
		},
		{
			name: '印度尼西亚',
			key: 'IDN'
		},
		{
			name: '葡萄牙',
			key: 'PRT'
		},
		{
			name: '马耳他',
			key: 'MLT'
		},
		{
			name: '塔吉克斯坦',
			key: 'TJK'
		},
		{
			name: '越南',
			key: 'VNM'
		},
		{
			name: '开曼群岛',
			key: 'CYM'
		},
		{
			name: '巴拉圭',
			key: 'PRY'
		},
		{
			name: '塞浦路斯',
			key: 'CYP'
		},
		{
			name: '塞舌尔',
			key: 'SYC'
		},
		{
			name: '卢旺达',
			key: 'RWA'
		},
		{
			name: '孟加拉国',
			key: 'BGD'
		},
		{
			name: '澳大利亚',
			key: 'AUS'
		},
		{
			name: '奥地利',
			key: 'AUT'
		},
		{
			name: '斯里兰卡',
			key: 'LKA'
		},
		{
			name: '加蓬',
			key: 'GAB'
		},
		{
			name: '津巴布韦',
			key: 'ZWE'
		},
		{
			name: '保加利亚',
			key: 'BGR'
		},
		{
			name: '叙利亚',
			key: 'SYR'
		},
		{
			name: '捷克',
			key: 'CZE'
		},
		{
			name: '挪威',
			key: 'NOR'
		},
		{
			name: '科特迪瓦',
			key: 'CIV'
		},
		{
			name: '缅甸',
			key: 'MMR'
		},
		{
			name: '基里巴斯',
			key: 'KIR'
		},
		{
			name: '土库曼斯坦',
			key: 'TKM'
		},
		{
			name: '格林纳达',
			key: 'GRD'
		},
		{
			name: '希腊',
			key: 'GRC'
		},
		{
			name: '海地',
			key: 'HTI'
		},
		{
			name: '格陵兰',
			key: 'GRL'
		},
		{
			name: '也门',
			key: 'YEM'
		},
		{
			name: '阿富汗',
			key: 'AFG'
		},
		{
			name: '蒙古',
			key: 'MNG'
		},
		{
			name: '尼泊尔',
			key: 'NPL'
		},
		{
			name: '巴哈马',
			key: 'BHS'
		},
		{
			name: '巴林',
			key: 'BHR'
		},
		{
			name: '波多黎各',
			key: 'PTR'
		},
		{
			name: '英国',
			key: 'ENG'
		},
		{
			name: '多米尼克',
			key: 'DMA'
		},
		{
			name: '波斯尼亚和黑塞哥维那',
			key: 'BIH'
		},
		{
			name: '匈牙利',
			key: 'HUN'
		},
		{
			name: '安哥拉',
			key: 'AGO'
		},
		{
			name: '萨摩亚',
			key: 'WSM'
		},
		{
			name: '法国',
			key: 'FRA'
		},
		{
			name: '东帝汶',
			key: 'TMP'
		},
		{
			name: '莫桑比克',
			key: 'MOZ'
		},
		{
			name: '纳米比亚',
			key: 'NAM'
		},
		{
			name: '秘鲁',
			key: 'PER'
		},
		{
			name: '圣文森特和格纳丁斯',
			key: 'VAG'
		},
		{
			name: '丹麦',
			key: 'DNK'
		},
		{
			name: '危地马拉',
			key: 'GTM'
		},
		{
			name: '所罗门群岛',
			key: 'SLB'
		},
		{
			name: '梵蒂冈城国',
			key: 'VAT'
		},
		{
			name: '塞拉利昂',
			key: 'SLE'
		},
		{
			name: '瑙鲁',
			key: 'NRU'
		},
		{
			name: '萨尔瓦多',
			key: 'SLV'
		},
		{
			name: '密克罗尼西亚联邦',
			key: 'FSM'
		},
		{
			name: '多米尼加',
			key: 'DOM'
		},
		{
			name: '喀麦隆',
			key: 'CMR'
		},
		{
			name: '圭亚那',
			key: 'GUY'
		},
		{
			name: '阿塞拜疆',
			key: 'AZE'
		},
		{
			name: '中国澳门',
			key: 'MAC'
		},
		{
			name: '格鲁吉亚',
			key: 'GEO'
		},
		{
			name: '汤加',
			key: 'TON'
		},
		{
			name: '新喀里多尼亚',
			key: 'NCL'
		},
		{
			name: '圣马力诺',
			key: 'SMR'
		},
		{
			name: '厄立特里亚',
			key: 'ERI'
		},
		{
			name: '圣其茨-尼维斯',
			key: 'KNA'
		},
		{
			name: '摩洛哥',
			key: 'MAR'
		},
		{
			name: '白俄罗斯',
			key: 'BLR'
		},
		{
			name: '毛里塔尼亚',
			key: 'MRT'
		},
		{
			name: '伯利兹',
			key: 'BLZ'
		},
		{
			name: '菲律宾',
			key: 'PHL'
		},
		{
			name: '民主刚果',
			key: 'COD'
		},
		{
			name: '刚果',
			key: 'COG'
		},
		{
			name: '西撒哈拉',
			key: 'ESH'
		},
		{
			name: '法属玻利尼西亚',
			key: 'PYF'
		},
		{
			name: '乌拉圭',
			key: 'URY'
		},
		{
			name: '库克群岛',
			key: 'COK'
		},
		{
			name: '科摩罗',
			key: 'COM'
		},
		{
			name: '哥伦比亚',
			key: 'COL'
		},
		{
			name: '美国',
			key: 'USA'
		},
		{
			name: '西班牙',
			key: 'ESP'
		},
		{
			name: '爱沙尼亚',
			key: 'EST'
		},
		{
			name: '百慕大',
			key: 'BMU'
		},
		{
			name: '蒙特塞拉特',
			key: 'MSR'
		},
		{
			name: '赞比亚',
			key: 'ZMB'
		},
		{
			name: '韩国',
			key: 'KOR'
		},
		{
			name: '索马里',
			key: 'SOM'
		},
		{
			name: '瓦努阿图',
			key: 'VUT'
		},
		{
			name: '厄瓜多尔',
			key: 'ECU'
		},
		{
			name: '阿尔巴尼亚',
			key: 'ALB'
		},
		{
			name: '摩纳哥',
			key: 'MCO'
		},
		{
			name: '埃塞俄比亚',
			key: 'ETH'
		},
		{
			name: '尼日尔',
			key: 'NER'
		},
		{
			name: '老挝',
			key: 'LAO'
		},
		{
			name: '委内瑞拉',
			key: 'VEN'
		},
		{
			name: '加纳',
			key: 'GHA'
		},
		{
			name: '佛得角',
			key: 'CPV'
		},
		{
			name: '马提尼克',
			key: 'MTQ'
		},
		{
			name: '摩尔多瓦',
			key: 'MDA'
		},
		{
			name: '圣皮埃尔和密克隆',
			key: 'SPM'
		},
		{
			name: '马达加斯加',
			key: 'MDG'
		},
		{
			name: '黎巴嫩',
			key: 'LBN'
		},
		{
			name: '利比里亚',
			key: 'LBR'
		},
		{
			name: '玻利维亚',
			key: 'BOL'
		},
		{
			name: '马尔代夫',
			key: 'MDV'
		},
		{
			name: '直布罗陀',
			key: 'GIB'
		},
		{
			name: '利比亚',
			key: 'LBY'
		},
		{
			name: '中国香港',
			key: 'HKG'
		},
		{
			name: '莱索托',
			key: 'LSO'
		},
		{
			name: '尼日利亚',
			key: 'NGA'
		},
		{
			name: '中非',
			key: 'CAF'
		},
		{
			name: '毛里求斯',
			key: 'MUS'
		},
		{
			name: '约旦',
			key: 'JOR'
		},
		{
			name: '几内亚',
			key: 'GIN'
		},
		{
			name: '加拿大',
			key: 'CAN'
		},
		{
			name: '罗马尼亚',
			key: 'ROM'
		},
		{
			name: '乍得',
			key: 'TCD'
		},
		{
			name: '安道尔',
			key: 'AND'
		},
		{
			name: '哥斯达黎加',
			key: 'CRI'
		},
		{
			name: '印度',
			key: 'IND'
		},
		{
			name: '墨西哥',
			key: 'MEX'
		},
		{
			name: '哈萨克斯坦',
			key: 'KAZ'
		},
		{
			name: '沙特阿拉伯',
			key: 'SAU'
		},
		{
			name: '荷属安地列斯群岛',
			key: 'ANT'
		},
		{
			name: '日本',
			key: 'JPN'
		},
		{
			name: '立陶宛',
			key: 'LTU'
		},
		{
			name: '特立尼达和多巴哥',
			key: 'TTO'
		},
		{
			name: '帕劳',
			key: 'PLW'
		},
		{
			name: '马拉维',
			key: 'MWI'
		},
		{
			name: '尼加拉瓜',
			key: 'NIC'
		},
		{
			name: '芬兰',
			key: 'FIN'
		},
		{
			name: '突尼斯',
			key: 'TUN'
		},
		{
			name: '卢森堡',
			key: 'LUX'
		},
		{
			name: '乌干达',
			key: 'UGA'
		},
		{
			name: '巴西',
			key: 'BRA'
		},
		{
			name: '土耳其',
			key: 'TUR'
		},
		{
			name: '巴巴多斯',
			key: 'BRB'
		},
		{
			name: '图瓦卢',
			key: 'TUV'
		},
		{
			name: '德国',
			key: 'DEU'
		},
		{
			name: '拉脱维亚',
			key: 'LVA'
		},
		{
			name: '埃及',
			key: 'EGY'
		},
		{
			name: '牙买加',
			key: 'JAM'
		},
		{
			name: '南非',
			key: 'ZAF'
		},
		{
			name: '洪都拉斯',
			key: 'HND'
		},
		{
			name: '文莱',
			key: 'BRN'
		},
	]
	return DataList
}
export default {
	TabFun,
	brrsNewFun,
	commonProbFun,
	Amount,
	viewLoadMerchantFile,
	getOssFile,
	listEnums,
	HolidayVerification,
	iconCountry,
	oriDataList,
	getMobileAreaCodes,
	REG_ZERO_INTEGER_FUN,
	special,
	EnglishOnly,
	RemoveChineseAndChineseSymbols,
	brrsFun
}
